import {generateFetchOptions} from '../index';

// POST /api/v1/oauth/linkedin/callback
export async function callback(provider: string, authorizationCode: string, state: string): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/users/oauth/${provider}/callback`,
    generateFetchOptions({
      method: 'POST',
      isProtected: true,
      body: {
        authorization_code: authorizationCode,
        state,
      },
    })
  );
}
